export { default } from "./QuickTipsItem.vue";
